export default {
  // Sets carousel index after a delay.
  // Make sure you set it to carousel to have it working.
  // Like <carousel v-model="carouselIndex"/>
  // Or like <carousel navigate-to="carouselIndex"/>
  data() {
    return { carouselIndex: 0 };
  },

  mounted() {
    this.$nextTick(this.fixAssholeCarousel);
  },

  methods: {
    fixAssholeCarousel() {
      // Change carousel index because navigating to a slide fixes buggy carousel.
      const index = this.carouselIndex;
      this.carouselIndex = index === 1 ? 0 : 1;
      setTimeout(() => {
        this.carouselIndex = index;
      }, 100);
    },
  },
};
